<template>
    <div>
        <base-crud crudName="Check-List" newText="Novo Check-List" :table="checkListTable" :columns="columns" :options="options"
            :endPoint='endPoint' :enableAdd="false" :enableEdit="false" :enableDelete="false" :enableView="false" :extra="extra" @view="view">
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

export default {
    data: function () {
        return {
            extra: [
                {
                    name: 'view',
                    label: '',
                    class: 'btn btn-primary btn-sm fa fa-eye text-white',
                    // style: 'color: #007bff; font-size: 1.2em;'
                }
            ],
            checkListTable: 'checkListTable',
            checkLists: [],
            pages: [],
            url: '',
            columns: ['id', 'name', 'branch_id', 'team_id', 'started_at', 'finished_at', 'actions'],
            tableData: ['id', 'name', 'branch_id', 'team_id', 'started_at', 'finished_at', 'actions'],
            options: {
                filterable: ['id', 'name'  ],
                filterByColumn: true,
                sortable: ['id', 'name'],
                pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    'id': 'ID',
                    'name': 'Nome',
                    // 'category_id': 'Categoria',
                    'branch_id': 'Unidade',
                    'team_id': 'Equipe',
                    'started_at': 'Iniciado em',
                    'finished_at': 'Finalizado em',
                    'actions': 'Ações'
                },
                templates: {
                    category_id: function (h, row, index) {
                        return row.category_name ? row.category_name : '';
                    },
                    branch_id: function (h, row, index) {
                        return row.branch ? row.branch.name : '';
                    },
                    team_id: function (h, row, index) {
                        return row.team ? row.team.name : '';
                    },
                    started_at: function (h, row, index) {
                        let started_at = row.started_at ? row.started_at : '';
                        if (started_at) {
                            started_at = new Date(started_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                        }

                        return started_at;
                    },
                    finished_at: function (h, row, index) {
                        let finished_at = row.finished_at ? row.finished_at : '';
                        if (finished_at) {
                            finished_at = new Date(finished_at).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                        }

                        return finished_at;
                    }
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ['category'];

                    return this.$http
                        .get(this.url + '?' + query, requestData)
                        .then(function (response) {
                            console.log("Response:", response);
                            return response; 
                        })
                        .catch(
                            function (e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                },
            },
            endPoint: 'checklists-execution?with[]=items&with[]=template&with[]=starter&with[]=finisher'
        }
    },
    methods: {
        query: function (query) {
            let columns = {
                id: 'id',
                name: 'name',
                // viewAllEvents: 'viewAllEvents',
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        },
        view(props, row, index) {
            this.$router.push({
                path: '/checklists-executed/view/' + props.row.id
            });
        }
    },
    components: {
        BaseCrud
    }
}
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckList/Executed.vue